<div style="height: 8px; background-color: rgba(16, 46, 94, 0.982)" class="col-12"></div>
<mat-card-header class="" style="cursor: grabbing" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <div class="row col-md-12">
    <div class="col-6">
      @if (!this.data.modif) {
        <div class="titre-modale">Ajouter une délégation</div>
      }
      @if (this.data.modif) {
        <div class="titre-modale">Modifier une délégation</div>
      }
    </div>

    <div class="col-md-6 text-end mb-2 mr-0 ml-auto gx-0">
      <button mat-dialog-close class="py-0" mat-icon-button aria-label="Example icon button with a vertical three dot icon">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</mat-card-header>
<mat-dialog-content class="mat-typography">
  <form [formGroup]="formAgentDelegation" class="row">
    <div class="col-12">
      <div class="row">
        <mat-label id="label-agent" class="label col-6 col-form-label">Agent *</mat-label>
        <div class="form-text mb-1">Sélectionnez l'agent.</div>
        <mat-form-field class="w-100">
          <input
            #autoCompleteAgent
            type="text"
            aria-label="agent"
            matInput
            name="agent"
            [matAutocomplete]="auto"
            formControlName="agent"
            (input)="agentFilter($event)"
            />

            @if (!this.data.modif && this.formAgentDelegation.get('agent')?.value) {
              <button
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="effaceFiltreDelegue($event, 'agent')"
                >
                <mat-icon>close</mat-icon>
              </button>
            }
            <mat-autocomplete #auto="matAutocomplete" hideSingleSelectionIndicator requireSelection [displayWith]="agentDeleguedisplayFn">
              @for (agent of filteredOptions; track agent) {
                <mat-option [disabled]="this.data.modif === true" [value]="agent">
                  {{ agent.nom }} {{ agent.prenom }}
                </mat-option>
              }
            </mat-autocomplete>
            @if (formAgentDelegation.get('agent')?.hasError('required') && formAgentDelegation.get('agent')?.touched) {
              <mat-error>
                L'agent est <strong>requis.</strong>
              </mat-error>
            }
            @if (formAgentDelegation.get('agent')?.hasError('agentExist') && formAgentDelegation.get('agent')?.value) {
              <mat-error>
                Vous ne pouvez pas être votre propre délégué
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="col-6">
        <div class="row">
          <label for="date_debut" id="label-dateDebut" class="label col-6 col-form-label">Date de début *</label>
          <div class="form-text mb-1">Sélectionnez ou saisissez date début, format DD/MM/YYYY.</div>
          <mat-form-field class="w-100">
            <input
              matInput
              type="text"
              [matDatepicker]="pi_date_debut"
              id="date_debut"
              formControlName="date_debut"
              [matDatepickerFilter]="FilterDebutDate"
              [min]="minDate"
              [matDatepickerFilter]="FilterDebutDate"
              required
              />
              <mat-datepicker-toggle matSuffix [for]="pi_date_debut"></mat-datepicker-toggle>
              <mat-datepicker #pi_date_debut></mat-datepicker>

              @if (formAgentDelegation.get('date_debut')?.hasError('required') && formAgentDelegation.get('date_debut')?.touched) {
                <mat-error>
                  La date de début est <strong>obligatoire</strong>
                </mat-error>
              }
              @if (formAgentDelegation.get('date_debut')?.hasError('invalidDate') && formAgentDelegation.get('date_debut')?.touched) {
                <mat-error
                  >
                  La date de début ne doit pas être supérieure à la date de fin.
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="col-6">
          <label for="date_fin" id="label-date_fin" class="label col-6 col-form-label">Date de fin *</label>
          <div class="form-text mb-1">Sélectionnez ou saisissez date fin, format DD/MM/YYYY.</div>
          <mat-form-field class="w-100">
            <input
              matInput
              type="text"
              [matDatepicker]="pi_date_fin"
              id="date_fin"
              formControlName="date_fin"
              [min]="minDate"
              [matDatepickerFilter]="FilterFinDate"
              required
              />
              <mat-datepicker-toggle matSuffix [for]="pi_date_fin"></mat-datepicker-toggle>
              <mat-datepicker #pi_date_fin></mat-datepicker>

              @if (formAgentDelegation.get('date_fin')?.hasError('required') && formAgentDelegation.get('date_fin')?.touched) {
                <mat-error>
                  La date de fin est <strong>obligatoire</strong>
                </mat-error>
              }
              @if (formAgentDelegation.get('date_fin')?.hasError('invalidDate') && formAgentDelegation.get('date_fin')?.touched) {
                <mat-error>
                  Date de fin doit être supérieure ou égale à date de début
                </mat-error>
              }
            </mat-form-field>
          </div>
        </form>
        <h5 class="text-footer">Les champs annotés d'un astérique * sont obligatoires.</h5>
      </mat-dialog-content>
      <mat-dialog-actions style="background-color: rgba(250, 250, 252, 1)" align="end">
        <button mat-stroked-button mat-dialog-close class="mx-3" color="primary">Annuler</button>
        <button mat-flat-button color="primary" [disabled]="formAgentDelegation.invalid || agentMatriculeExist()" (click)="saveDelegue()">
          Valider
        </button>
      </mat-dialog-actions>
